import { useEffect, useRef } from 'react';

const useAudioAnalytics = (currentItem, isPlaying, isRadioMode) => {
  const isPlayingRef = useRef(isPlaying);
  useEffect(() => {
    isPlayingRef.current = isPlaying;
  }, [isPlaying]);

  // Track Virtual Page View on Item Change
  useEffect(() => {
    if (
      currentItem?.id &&
      typeof window !== 'undefined' &&
      typeof window.gtag === 'function'
    ) {
      window.gtag('event', 'page_view', {
        page_title: currentItem.title,
        page_location: window.location.href,
        page_path: window.location.pathname + window.location.search,
        send_to: window['ga-measurement-id'],
      });
    }
  }, [currentItem?.id]);

  // Engagement Heartbeat (Every 30s, only if playing)
  useEffect(() => {
    const googleTag = () => {
      try {
        if (
          typeof window !== 'undefined' &&
          typeof window.gtag === 'function' &&
          isPlayingRef.current &&
          currentItem?.id
        ) {
          window.gtag('event', 'audio_heartbeat', {
            event_category: 'engagement',
            event_label: currentItem.title,
            item_id: currentItem.id,
            value: 30,
            stream_type: isRadioMode ? 'radio' : 'on_demand',
          });
        }
      } catch (err) {
        console.error(err);
      }
    };

    const interval = setInterval(googleTag, 30000);
    return () => clearInterval(interval);
  }, [currentItem?.id, isRadioMode]);
};

export default useAudioAnalytics;
